import {
    Component,
    ElementRef,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Events } from "@type-r/models";
import * as React from "react";
import { FunctionComponent } from "react";
import * as ReactDOM from "react-dom";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { AppConfigService } from "src/app/services/app-config.service";
import { RestfulEndpoint } from "../api/endpoint";
import { RestService } from "../src/app/services/rest.service";

@Component({
    selector: "react-page",
    template: '<div class="react-page" #container></div>'
})
export class ReactPageComponent implements OnInit, OnDestroy {
    private QueryParams: any;
    @ViewChild("container", { static: true }) containerRef: ElementRef;

    constructor(
        private rest: RestService,
        private router: Router,
        public zone: NgZone,
        private appConfig: AppConfigService
    ) {
        Events.trigger("appConfig:loaded", appConfig);
    }

    Component: React.FunctionComponent<{ ngContext?: any }>;
    private _routerEvents: Subscription;

    ngOnInit() {
        this.reactPageWillMount()
            .then(() => this.mountReactPage());
    }

    ngOnDestroy() {
        Events.off("navigate");
        this._routerEvents && this._routerEvents.unsubscribe();

        unmountReact(this.containerRef);
    }

    async reactPageWillMount(): Promise<void> {
        // console.log('mounting react page')
    }

    mountReactPage() {
        Events.on("navigate", (url: string, anchor: string, queryParams) => {
            const location = url.split('?');
            const pathname = location[ 0 ];
            const urlQueryParams = location
                .slice(1)
                .reduce((acc, queryParam) => {
                    const query = queryParam.split('=');
                    return { ...acc, [ query[ 0 ] ]: query[ 1 ] }
                }, {});
            queryParams = { ...queryParams, ...urlQueryParams };
            this.QueryParams = { ...queryParams };

            if (queryParams.returnUrl) {
                queryParams.returnUrl = decodeURIComponent(queryParams.returnUrl);
            }

            if (queryParams && HiddenQueryParmsList.length) {
                HiddenQueryParmsList.forEach(p => {
                    if (queryParams[ p ])
                        delete queryParams[ p ];
                });
            }

            this.zone.run(() => this.router.navigate([ pathname, {} ], { queryParams, fragment: anchor }));
        });

        const ngContext = ((window as any).context = RestfulEndpoint.ngContext = {
            baseUrl: (this.rest as any).baseUrl
        });

        const config = this.appConfig.getConfig();
        mountReact(this.containerRef, this.Component, {
            ngContext,
            appConfig: config
        });

        // When the route changes, we update react page.
        this._routerEvents = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                mountReact(this.containerRef, this.Component, {
                    ngContext,
                    appConfig: config,
                    queryParams: this.QueryParams
                });
            });
    }
}

export function mountReact(
    containerRef: ElementRef<any>,
    Component: FunctionComponent,
    props = {}
) {
    ReactDOM.render(
        React.createElement(Component, props),
        containerRef.nativeElement
    );

    window.addEventListener('beforeunload', (evt) => {
        unmountReact(containerRef);

        return true;
    });
}

export function unmountReact(containerRef: ElementRef<any>) {
    ReactDOM.unmountComponentAtNode(containerRef.nativeElement);
}

const HiddenQueryParmsList = [
    'importJobId'
]
